import ParallaxSections from "../ParllaxSections";

export default function About() {
  return (
    <div>

      {/* <div className="text-center text-2xl font-bold text-green-500">
        About Page

      </div> */}
      <div className="w-full animate-fade-right animate-once animate-duration-[2500ms] animate-delay-300 bg-blue-500 text-white p-4 rounded">
        Welcome to NexITus!
      </div>

      <div className="relative w-full text-gray-100 body-font pb-48 md:pb-0 mb-48 md:mb-0">
        <section className="relative w-full text-gray-100 body-font pb-12 md:pb-0">
          <div className="flex justify-center mt-10 text-4xl font-regular">
            Why Us?
          </div>
          <div className="container px-5 py-12 mx-auto">
            <div className="flex flex-wrap text-center justify-center">
              <div className="p-4 md:w-1/4 sm:w-1/2">
                <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                  <div className="flex justify-center">
                    <img src="../images/CanadaMapleLeaf.png" className="w-32 mb-3"></img>
                  </div>
                  <h2 className="title-font font-regular text-2xl text-gray-300">We Support Canadian Businesses</h2>
                </div>
              </div>

              <div className="p-4 md:w-1/4 sm:w-1/2">
                <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                  <div className="flex justify-center">
                    <img src="https://image2.jdomni.in/banner/13062021/3E/57/E8/1D6E23DD7E12571705CAC761E7_1623567977295.png?output-format=webp" className="w-32 mb-3"></img>
                  </div>
                  <h2 className="title-font font-regular text-2xl text-gray-300">Reasonable Rates</h2>
                </div>
              </div>

              <div className="p-4 md:w-1/4 sm:w-1/2">
                <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                  <div className="flex justify-center">
                    <img src="https://image3.jdomni.in/banner/13062021/16/7E/7E/5A9920439E52EF309F27B43EEB_1623568010437.png?output-format=webp" className="w-32 mb-3"></img>
                  </div>
                  <h2 className="title-font font-regular text-2xl text-gray-300">Time Efficiency</h2>
                </div>
              </div>

              <div className="p-4 md:w-1/4 sm:w-1/2">
                <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                  <div className="flex justify-center">
                    <img src="https://image3.jdomni.in/banner/13062021/EB/99/EE/8B46027500E987A5142ECC1CE1_1623567959360.png?output-format=webp" className="w-32 mb-3"></img>
                  </div>
                  <h2 className="title-font font-regular text-2xl text-gray-300">Expertise in Industry</h2>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
      <ParallaxSections></ParallaxSections>
    </div>
  );
}
